import { useMutation, useQueryClient } from "@tanstack/react-query";
import userModel from "./firebase/userModel";
import { userKeys } from "./queryKeys";
import { message } from "antd";
import { useContext } from "react";
import { AuthContext } from "../context/AuthProvider";
import { trackEvent } from "../helpers/mixpanel";

export default function useCreateProfileMutation() {
  const queryClient = useQueryClient();
  const { user } = useContext(AuthContext);

  const mutationResult = useMutation({
    mutationFn: async (data) => {
      return await userModel.create(data);
    },
    onSuccess: ({ username }) => {
      queryClient.invalidateQueries({ queryKey: userKeys.all });
      message.success("Profile created successfully!");

      // Up until this point, userInfo will have been null (namely in the AuthProvider). This resets it.
      queryClient.invalidateQueries({
        queryKey: userKeys.user(user.uid),
      });

      trackEvent(
        "Completed Profile Creation",
        {
          email: user?.email.toLocaleLowerCase(),
        },
        true
      );
    },
    onError: (error) => {
      console.error("Error creating profile:", error);
      message.error("Failed to create profile. Please try again.");
    },
  });

  return mutationResult;
}
